import { render, staticRenderFns } from "./custorm-them-configr.vue?vue&type=template&id=4294ffc2"
import script from "./custorm-them-configr.vue?vue&type=script&setup=true&lang=js"
export * from "./custorm-them-configr.vue?vue&type=script&setup=true&lang=js"
import style0 from "./custorm-them-configr.vue?vue&type=style&index=0&id=4294ffc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_qhqm3mauky62uixplfzayyuc5e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports